import { useQuery } from '@tanstack/react-query';
import { useAuthStore } from './useAuthStore';
import { api } from '../services/api';

export interface TherapistSetupProfile {
  status: 'pending' | 'verified' | 'suspended';
  profilePhotoUrl?: string | null;
  credentialDocs?: { docType: string }[];
}

export function therapistNeedsOnboarding(
  profile: TherapistSetupProfile | null | undefined
): boolean {
  return profile?.status === 'pending' && (profile.credentialDocs?.length ?? 0) === 0;
}

export function useTherapistSetup() {
  const isTherapist = useAuthStore((state) => state.user?.role === 'therapist');
  return useQuery({
    queryKey: ['therapist-setup'],
    queryFn: () => api.get<TherapistSetupProfile>('/therapists/me/profile'),
    enabled: isTherapist,
    staleTime: 60_000,
  });
}
